import Cookies from 'js-cookie'

export const openLoginModalWithRedirect = (
  router: { replace: (href: string) => void },
  redirectTo: string,
) => {
  const token = Cookies.get('access_token')

  if (token) {
    return false
  }

  const currentUrl = new URL(window.location.href)
  currentUrl.searchParams.set('login', '1')
  currentUrl.searchParams.set('redirect', redirectTo)

  router.replace(`${currentUrl.pathname}?${currentUrl.searchParams.toString()}`)
  return true
}
